// This input is used to select a semester in the term form
import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters([ 'semesterNames' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: Object.keys(this.semesterNames || {}),
        ...this.config,
      }
    },
    normalizedOptions () {
      return this.mergedConfig.options || []
    },
  },
  methods: {
    getSemesterName (semester) {
      return this.semesterNames[semester] || semester
    },
    normalizedOptionLabel (option) {
      return this.getSemesterName(option)
    },
  },
}
